const MODULE_LABELS = {
  dashboard: { label: 'Painel Principal', description: 'Dashboard e visão geral do negócio.' },
  financial_analysis: { label: 'Análise Financeira', description: 'Leituras, margens e indicadores financeiros.' },
  risk_management: { label: 'Gestão de Risco', description: 'Controlo e análise de risco.' },
  inventory: { label: 'Inventário', description: 'Produtos, stock e transferências.' },
  kits: { label: 'Kits / Bundles', description: 'Composição e gestão de kits.' },
  sales: { label: 'Vendas', description: 'Vendas, POS e auditoria comercial.' },
  documents: { label: 'Documentos', description: 'Cotações, guias e documentos comerciais.' },
  services: { label: 'Serviços', description: 'Serviços, reparações e atendimento técnico.' },
  procurement: { label: 'Compras', description: 'Procurement, pedidos e compras.' },
  cash: { label: 'Caixa', description: 'Sessões e operação de caixa.' },
  receivables: { label: 'Contas a Receber', description: 'Cobranças e valores pendentes.' },
  expenses: { label: 'Despesas', description: 'Registo e gestão de despesas.' },
  payroll: { label: 'Payroll', description: 'Folha salarial e processamento.' },
  pricing: { label: 'Preçário', description: 'Preços, margens e pricing.' },
  clients: { label: 'Clientes', description: 'CRM e registos de clientes.' },
  suppliers: { label: 'Fornecedores', description: 'Gestão de fornecedores.' },
  licenses: { label: 'Licenças', description: 'Licenças e contratos activos.' },
  alerts: { label: 'Alertas', description: 'Alertas e monitorização.' },
  catalogs: { label: 'Catálogos', description: 'Catálogos e taxonomias do sistema.' },
  users: { label: 'Utilizadores', description: 'Contas, utilizadores e centros administrativos.' },
  reports: { label: 'Relatórios', description: 'Relatórios, exportações e agendamentos.' },
  whatsapp: { label: 'WhatsApp', description: 'Módulo de atendimento e comunicação.' },
  feedback: { label: 'Feedback', description: 'Feedback operacional e acompanhamento.' },
  integrity: { label: 'Integridade', description: 'Validações, alertas e integridade.' },
  projects: { label: 'Obras / Projectos', description: 'Obras técnicas, assinaturas e progresso.' },
  settings: { label: 'Configurações', description: 'Parâmetros e preferências do ERP.' },
  roles: { label: 'Perfis & Permissões', description: 'Perfis, acessos e governança RBAC.' },
  about: { label: 'Sobre / Manuais', description: 'Manual, dossier e relatório final.' },
  about_training: { label: 'Documentação e Formação', description: 'PDFs, leitura, aceite e relatórios de formação.' },
};

export const getPermissionModuleKey = (permissionSlug = '') => {
  if (!permissionSlug || permissionSlug === '*') return 'admin';
  return String(permissionSlug).split('.')[0];
};

export const buildPermissionModules = (permissions = []) => {
  const groups = permissions.reduce((accumulator, permission) => {
    const moduleKey = getPermissionModuleKey(permission.slug);
    if (moduleKey === 'admin') return accumulator;

    if (!accumulator[moduleKey]) {
      accumulator[moduleKey] = {
        key: moduleKey,
        label: MODULE_LABELS[moduleKey]?.label || moduleKey.replace(/_/g, ' '),
        description: MODULE_LABELS[moduleKey]?.description || permission.group || 'Módulo do sistema',
        permissions: [],
      };
    }

    accumulator[moduleKey].permissions.push(permission);
    return accumulator;
  }, {});

  return Object.values(groups).sort((left, right) => left.label.localeCompare(right.label, 'pt'));
};

export const normalizeProfilePermissions = (profilePermissions = [], permissionCatalog = []) => {
  const validSlugs = new Set((permissionCatalog || []).map((permission) => permission.slug).filter(Boolean));
  if ((profilePermissions || []).includes('*')) {
    return [...validSlugs].sort((left, right) => left.localeCompare(right, 'pt'));
  }

  return [...new Set((profilePermissions || []).filter((permission) => validSlugs.has(permission)))].sort((left, right) => left.localeCompare(right, 'pt'));
};

export const enrichProfilesWithModuleSummary = (profiles = [], permissionCatalog = []) => {
  const modules = buildPermissionModules(permissionCatalog);

  return profiles.map((profile) => {
    const normalizedPermissions = normalizeProfilePermissions(profile.permissions || [], permissionCatalog);
    const activeModules = modules.filter((module) => module.permissions.some((permission) => normalizedPermissions.includes(permission.slug)));
    const hasFullAccess = (profile.permissions || []).includes('*');

    return {
      ...profile,
      normalizedPermissions,
      activeModules,
      activeModuleCount: hasFullAccess ? modules.length : activeModules.length,
      permissionCountResolved: hasFullAccess ? permissionCatalog.length : normalizedPermissions.length,
      isFullAccess: hasFullAccess,
      profileTypeLabel: profile.type === 'base' ? 'Perfil do sistema' : 'Perfil criado',
    };
  });
};